import type { AutomationTestExecutionIntegrityDisposition } from '@/types/automations.ts';

const EXECUTION_INTEGRITY_LABELS: Record<AutomationTestExecutionIntegrityDisposition, string> = {
  clean_completion: 'clean completion',
  safe_route_attested: 'expected route attested safely',
  expected_failure_recovered: 'expected failure recovered',
  expected_failure_rethrown: 'expected failure rethrown',
  expected_failure_terminal: 'expected root failure verified',
  unexpected_partial_completion: 'undeclared execution issues',
  route_mismatch: 'route mismatch',
  failure_terminal_mismatch: 'failure-terminal mismatch',
  recovery_incomplete: 'recovery incomplete',
  unrelated_execution_failure: 'unrelated execution failure',
  invalid_execution_evidence: 'execution evidence incomplete',
};

export const formatExecutionIntegrityDisposition = (
  disposition?: AutomationTestExecutionIntegrityDisposition | null,
) => (disposition ? EXECUTION_INTEGRITY_LABELS[disposition] : null);
